/* src/app/components/job/details.modal.scss */
ion-card-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/*# sourceMappingURL=details.modal.css.map */
